export default "__VITE_ASSET__B_$uIRU5__"